import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { fetchOfferingQueryFn } from './fetch-offering.query';
export const fetchMoneyFormatterQueryFn = async props => {
  const {
    httpClient,
    request: formatterOptions
  } = props;
  const {
    currencySettings
  } = await fetchOfferingQueryFn({
    httpClient,
    request: {}
  });
  if (!currencySettings) {
    return {
      formatMoney: (money, _overrides) => money
    };
  }
  const formatter = PremiumPurchasePlatformModule.SDK.CurrencyUtils.createCurrencyFormatter({
    currencySettings,
    ...{
      hideZeroDecimals: true,
      maximumFractionDigits: 0,
      ...formatterOptions
    }
  });
  const formatMoney = (money, overrides) => {
    if (!(money != null && money.amount) || !currencySettings.code) {
      return money;
    }

    // TODO - talk with platform about formatMoney function, should take money type and return money type
    const formattedAmount = formatter.format({
      amount: money.amount,
      currency: money.currency ?? currencySettings.code
    }, {
      ...overrides
    });
    return {
      ...money,
      formattedAmount
    };
  };
  return {
    formatMoney
  };
};
//# sourceMappingURL=fetch-money-formatter.query.js.map